import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { PHONE_HREF } from "@/components/Nav";

const services = [
  {
    n: "01",
    title: "House & Garage Cleanouts",
    desc: "Furniture, appliances, boxes, years of stuff — cleared out in one visit.",
    span: "md:col-span-7",
  },
  {
    n: "02",
    title: "Moving & Estate Cleanouts",
    desc: "Moving out or handling an estate? We empty whatever gets left behind.",
    span: "md:col-span-5",
  },
  {
    n: "03",
    title: "Landlord & Property Turnovers",
    desc: "Units cleared fast between tenants so you can relist sooner.",
    span: "md:col-span-5",
  },
  {
    n: "04",
    title: "Office & Business Hauling",
    desc: "Desks, shelving, old inventory, renovation debris — hauled off your site.",
    span: "md:col-span-7",
  },
];

export default function Services() {
  return (
    <section className="bg-white px-5 py-20 sm:px-10 lg:py-28 xl:px-16" data-testid="services-section">
      <div className="mb-12 flex flex-wrap items-end justify-between gap-6">
        <div>
          <p className="mb-3 font-mono2 text-[11px] uppercase tracking-[0.35em] text-royal">What we haul</p>
          <h2 className="font-display text-5xl uppercase leading-none text-navy sm:text-7xl">
            Point at it.<br />It's gone.
          </h2>
        </div>
        <p className="max-w-xs text-sm text-navy/60 md:text-base">
          One call covers the whole job — we load, haul, and leave the space empty.
        </p>
      </div>
      <div className="grid grid-cols-1 gap-6 md:grid-cols-12">
        {services.map((s, i) => (
          <motion.a
            key={s.n}
            href={PHONE_HREF}
            data-testid={`service-card-${s.n}`}
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.7, delay: i * 0.08, ease: [0.16, 1, 0.3, 1] }}
            className={`group flex flex-col justify-between border border-navy/20 bg-white p-8 transition-[background-color,transform,box-shadow] duration-200 hover:-translate-y-1 hover:bg-navy hover:shadow-[8px_8px_0_0_#1d4ed8] lg:p-12 ${s.span}`}
          >
            <div className="flex items-start justify-between">
              <span className="font-display text-2xl text-royal transition-colors duration-200 group-hover:text-white/70">
                {s.n}
              </span>
              <ArrowUpRight className="h-6 w-6 text-navy/30 transition-colors duration-200 group-hover:text-white" strokeWidth={2} />
            </div>
            <div className="mt-16">
              <h3 className="font-display text-3xl uppercase leading-tight text-navy transition-colors duration-200 group-hover:text-white sm:text-4xl">
                {s.title}
              </h3>
              <p className="mt-3 max-w-sm text-sm text-navy/60 transition-colors duration-200 group-hover:text-white/70 md:text-base">
                {s.desc}
              </p>
            </div>
          </motion.a>
        ))}
      </div>
    </section>
  );
}
